import React, { useEffect, useState } from 'react';
import Header from '../../layouts/Header';
import { Button, Col, Dropdown, Form, Modal, Row, Spinner, InputGroup } from 'react-bootstrap';
import { toast } from 'react-toastify';
import ReusableTable from '../../components/ReusableTable';
import axios from '../../api/axios';
import Select from "react-select";
import makeAnimated from "react-select/animated";
import PermissionSelector from '../../components/PermissionSelector';
import { useSelector } from 'react-redux';

const AdminUserMgt = () => {
    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [userMgtAccess, setUserMgtAccess] = useState([]);

    console.log("Access :", access);

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("UserMgt:")
            );
            setUserMgtAccess(filteredAccess);
        }
    }, [access]);
    
    console.log("User Mgt Access :", userMgtAccess);
    
    const accessToken = localStorage.getItem('authToken');
    const [searchText, setSearchText] = useState('');
    const [roles, setRoles] = useState([]);
    const [isAddBtnLoading, setIsAddBtnLoading] = useState(false);
    const [userInputData, setUserInputData] = useState({
        name: '',
        email: '',
        password: '',
        access: []
    });
    const [selectedRole, setSelectedRole] = useState('');
    const [errors, setErrors] = useState({});
    const [dataLoading, setDataLoading] = useState(false);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [usersList, setUsersList] = useState([]);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [filteredData, setFilteredData] = useState([]);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [editedData, setEditedData] = useState({});
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [componentData, setComponentData] = useState([
        {
            category: 'Dashboard',
            components: [
                { name: 'Dashboard', actions: ['get'] },
            ]
        },
        { 
            category: 'AllReports', 
            components: [
                { name: 'CustomerReport', actions: ['get'] },
                { name: 'OrdersReport', actions: ['get', 'update'] },
                { name: 'KioskUserReport', actions: ['get'] },
                { name: 'UserAnalyticsReport', actions: ['get'] },
                { name: 'ProductSalesReport', actions: ['get'] },
                { name: 'ItemWiseReport', actions: ['get'] },
                { name: 'AddonSalesReport', actions: ['get'] },
                { name: 'CouponsReport', actions: ['get'] },
                { name: 'DaySummaryReport', actions: ['get'] },
                { name: 'MonthSummaryReport', actions: ['get'] },
                { name: 'OutletStockReport', actions: ['get'] },
                { name: 'StorageLocationStockReport', actions: ['get'] },
                { name: 'RmReorderLevel', actions: ['get'] },
                { name: 'ProductOutofStockReport', actions: ['get'] },
                { name: 'RmCentralStockReport', actions: ['get'] },
                { name: 'SubscriptionPurchaseReport', actions: ['get'] },
                { name: 'SubscriptionConsumptionReport', actions: ['get'] },
                { name: 'CentralStockTransaction', actions: ['get'] },
                { name: 'OutletStockTransaction', actions: ['get'] },
            ]
        },
        { 
            category: 'Admin User Mgt', 
            components: [
                { name: 'UserMgt', actions: ['add', 'get', 'update', 'delete'] },
                // { name: 'Roles', actions: ['add', 'get', 'update', 'delete'] },
            ]
        },
        { 
            category: 'Food Delivery App', 
            components: [
                { name: 'FoodDeliveryApp', actions: ['add', 'get', 'update', 'delete'] },
                // { name: 'Roles', actions: ['add', 'get', 'update', 'delete'] },
            ]
        },
        { 
            category: 'Material Mgt', 
            components: [
                { name: 'RawMaterials', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'RmSubCategory', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'RmMainCategory', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'StorageLocation', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'Vendors', actions: ['add', 'get', 'update', 'delete'] },
            ]
        },
        {
            category: 'Menu', 
            components: [
                { name: 'CategoryMgt', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'AddMenu', actions: ['add'] },
                { name: 'MenuCatalog', actions: ['get', 'update', 'delete']},
                { name: 'MenuIngredients', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'MenuGroup', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'MenuPricing', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'AddonGroups', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'AddonAllocation', actions: ['add', 'get', 'update', 'delete'] },
            ]
        },
        {
            category: 'Outlet Mgt', 
            components: [
                { name: 'Outlet', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'PettyCash', actions: ['add', 'get', 'update'] },
                { name: 'OutletUser', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'KioskUser', actions: ['add', 'get', 'update', 'delete'] },
            ]
        },
        {
            category: 'requests Indent', 
            components: [
                { name: 'FoodRequest', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'BeverageRequest', actions: ['add', 'get', 'update'] },
                { name: 'CentralRequest', actions: ['add', 'get', 'update', 'delete'] },
            ]
        },
        {
            category: 'Purchase / Outwards',
            components: [
                { name: 'PurchaseList', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'PurchaseUnits', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'OutletStockTransfer', actions: ['add'] },
                { name: 'StorageLocationStTransfer', actions: ['add'] },
                { name: 'RmDamageEntries', actions: ['add'] },

            ]
        },
        {
            category: 'Support',
            components: [
                { name: 'CustomerSupportMgt', actions: ['get'] },
                { name: 'CancellationRequest', actions: ['get'] },
                { name: 'FranchiseEnquiry', actions: ['get'] },
            ]
        },
        {
            category: 'User Levels',
            components: [
                { name: 'Level', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'AddLevelRewards', actions: ['add'] },
                { name: 'ViewLevelRewards', actions: ['get', 'update', 'delete'] },
            ]
        },
        {
            category: 'Content Management',
            components: [
                { name: 'AdvertisementMgt', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'PopupAdvertisement', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'PromoteProducts', actions: ['add', 'get', 'update'] },
            ]
        },
        {
            category: 'Coupon Management',
            components: [
                { name: 'CreateCoupon', actions: ['add'] },
                { name: 'Coupons', actions: ['get', 'update', 'delete'] },
                { name: 'UserCouponAllocation', actions: ['add', 'get', 'update', 'delete'] },
            ]
        },
        {
            category: 'Subscription',
            components: [
                { name: 'CreateSubscription', actions: ['add'] },
                { name: 'Subscriptions', actions: ['get', 'update', 'delete'] },
            ]
        },
        {
            category: 'System Preference',
            components: [
                { name: 'AppVersion', actions: ['get', 'add', 'update', 'delete'] },
                { name: 'Settings', actions: ['get', 'update' ] },
                { name: 'Logs', actions: ['get'] },
            ]
        },
    ]);
    const [selectedComponentData, setSelectedComponentData] = useState([]);
    const [userId, setUserId] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showEditPassword, setShowEditPassword] = useState(false);
    const animatedComponents = makeAnimated();
    const [showPermissionsModal, setShowPermissionsModal] = useState(false);
    const [modalPermissions, setModalPermissions] = useState([]);
    const [modalTitle, setModalTitle] = useState('');

    const components = componentData?.map((comp) => ({
        value: comp,
        label: comp,
    }));

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: "6px",
            minWidth: "200px",
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d",
        }),
    };

    // Function to generate a random password
    const generatePassword = () => {
        const length = 12;
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
        let password = "";
        for (let i = 0; i < length; i++) {
            password += charset.charAt(Math.floor(Math.random() * charset.length));
        }
        return password;
    };

    // Function to handle password generation
    const handleGeneratePassword = () => {
        const newPassword = generatePassword();
        setUserInputData(prev => ({
            ...prev,
            password: newPassword
        }));
    };

    // Function to toggle password visibility
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    // Function to toggle edit password visibility
    const toggleEditPasswordVisibility = () => {
        setShowEditPassword(!showEditPassword);
    };

    // Function to format access permissions for display
    // const formatAccessPermissions = (accessData) => {
    //     if (!accessData || accessData.length === 0) {
    //         return <span className="text-muted">No permissions assigned</span>;
    //     }

    //     if (Array.isArray(accessData)) {
    //         // If it's a simple array of strings
    //         if (accessData.every(item => typeof item === 'string')) {
    //             return (
    //                 <div className="d-flex flex-wrap gap-1">
    //                     {accessData.slice(0, 3).map((permission, index) => (
    //                         <span key={index} className="badge bg-primary">
    //                             {permission}
    //                         </span>
    //                     ))}
    //                     {accessData.length > 3 && (
    //                         <span className="badge bg-secondary">
    //                             +{accessData.length - 3} more
    //                         </span>
    //                     )}
    //                 </div>
    //             );
    //         }
            
    //         // If it's an array of objects with component and actions
    //         if (accessData.every(item => typeof item === 'object' && item.component)) {
    //             return (
    //                 <div>
    //                     {accessData.slice(0, 2).map((item, index) => (
    //                         <div key={index} className="mb-1">
    //                             <small>
    //                                 <span className="fw-semibold">{item.component}:</span>
    //                                 <span className="ms-1">
    //                                     {item.actions ? item.actions.join(', ') : 'No actions'}
    //                                 </span>
    //                             </small>
    //                         </div>
    //                     ))}
    //                     {accessData.length > 2 && (
    //                         <div className="text-primary">
    //                             <small>+{accessData.length - 2} more permissions</small>
    //                         </div>
    //                     )}
    //                 </div>
    //             );
    //         }
    //     }
        
    //     // If it's a string with colon-separated permissions
    //     if (typeof accessData === "string") {
    //         const permissions = accessData.split(":");
    //         return (
    //             <div className="d-flex flex-wrap gap-1">
    //                 {permissions.slice(0, 3).map((permission, index) => (
    //                     <span key={index} className="badge bg-primary">
    //                         {permission.trim()}
    //                     </span>
    //                 ))}
    //                 {permissions.length > 3 && (
    //                     <span className="badge bg-secondary">
    //                         +{permissions.length - 3} more
    //                     </span>
    //                 )}
    //             </div>
    //         );
    //     }
        
    //     // Default case
    //     return <span>{JSON.stringify(accessData)}</span>;
    // };
    // Function to format access permissions for display
    // const formatAccessPermissions = (accessData) => {
    //     if (!accessData || accessData.length === 0) {
    //         return <span className="text-muted">No permissions assigned</span>;
    //     }

    //     console.log("Access Data :", accessData);
        

    //     const handleShowMore = (permissions, title) => {
    //         setModalPermissions(permissions);
    //         setModalTitle(title);
    //         setShowPermissionsModal(true);
    //     };

    //     if (Array.isArray(accessData)) {
    //         // If it's a simple array of strings
    //         if (accessData.every(item => typeof item === 'string')) {
    //             return (
    //                 <div className="d-flex flex-wrap gap-1">
    //                     {accessData?.slice(0, 3).map((permission, index) => (
    //                         <span key={index} className="badge bg-primary">
    //                             {permission}
    //                         </span>
    //                     ))}
    //                     {accessData.length > 3 && (
    //                         <span 
    //                             className="badge bg-secondary"
    //                             style={{ cursor: 'pointer' }}
    //                             onClick={() => handleShowMore(accessData?.slice(3), 'All Permissions')}
    //                         >
    //                             +{accessData?.length - 3} more
    //                         </span>
    //                     )}
    //                 </div>
    //             );
    //         }
            
    //         // If it's an array of objects with component and actions
    //         if (accessData.every(item => typeof item === 'object' && item.component)) {
    //             return (
    //                 <div>
    //                     {accessData.slice(0, 2).map((item, index) => (
    //                         <div key={index} className="mb-1">
    //                             <small>
    //                                 <span className="fw-semibold">{item.component}:</span>
    //                                 <span className="ms-1">
    //                                     {item.actions ? item.actions.join(', ') : 'No actions'}
    //                                 </span>
    //                             </small>
    //                         </div>
    //                     ))}
    //                     {accessData.length > 2 && (
    //                         <div 
    //                             className="text-primary"
    //                             style={{ cursor: 'pointer' }}
    //                             onClick={() => handleShowMore(accessData.slice(2), 'All Permissions')}
    //                         >
    //                             <small>+{accessData.length - 2} more permissions</small>
    //                         </div>
    //                     )}
    //                 </div>
    //             );
    //         }
    //     }
        
    //     // If it's a string with colon-separated permissions
    //     if (typeof accessData === "string") {
    //         const permissions = accessData.split(":");
    //         return (
    //             <div className="d-flex flex-wrap gap-1">
    //                 {permissions.slice(0, 3).map((permission, index) => (
    //                     <span key={index} className="badge bg-primary">
    //                         {permission.trim()}
    //                     </span>
    //                 ))}
    //                 {permissions.length > 3 && (
    //                     <span 
    //                         className="badge bg-secondary"
    //                         style={{ cursor: 'pointer' }}
    //                         onClick={() => handleShowMore(permissions.slice(3), 'All Permissions')}
    //                     >
    //                         +{permissions.length - 3} more
    //                     </span>
    //                 )}
    //             </div>
    //         );
    //     }
        
    //     // Default case
    //     return <span>{JSON.stringify(accessData)}</span>;
    // };

    const formatAccessPermissions = ( accessData ) => {
        if (!accessData || accessData.length === 0) {
            return <span className="text-muted">No permissions assigned</span>;
        }

        const handleShowPermissions = (permissions, title) => {
            console.log("permissons :", permissions);
            
            // if (setModalPermissions && setModalTitle && setShowPermissionsModal) {
                setModalPermissions(permissions);
                setModalTitle(title);
                setShowPermissionsModal(true);
            // }
        };

        // Count total permissions
        const countPermissions = (data) => {
            let count = 0;
            
            if (Array.isArray(data)) {
            data.forEach(permission => {
                if (typeof permission === "string") {
                count += 1;
                } else if (typeof permission === "object" && permission.component && permission.actions) {
                count += permission.actions.length;
                }
            });
            }
            
            return count;
        };

        let permissionsArray = [];
        let totalPermissions = 0;

        if (Array.isArray(accessData)) {
            permissionsArray = accessData;
            totalPermissions = countPermissions(accessData);
        } else if (typeof accessData === "string") {
            permissionsArray = [accessData];
            totalPermissions = 1;
        } else {
            return <span>{JSON.stringify(accessData)}</span>;
        }

        return (
            <div>
                <span className="text-muted">{totalPermissions} permission{totalPermissions !== 1 ? 's' : ''}</span>
                <div
                    className="text-primary mt-1"
                    style={{ cursor: "pointer", fontSize: "0.875rem" }}
                    onClick={() => handleShowPermissions(permissionsArray, "All Permissions")}
                >
                    View all permissions
                </div>
            </div>
        );
    };

    const columns = [
        { header: "Sr.No", accessor: "serialNumber" },
        {
            header: "User Name",
            accessor: "name",
            render: (value, row) => (
                <div>
                    <span className="mb-0">{value}</span>
                </div>
            ),
        },
        // {
        //     header: "Created On",
        //     accessor: "createdAt",
        //     render: (value, row) => {
        //         const formattedDate = new Date(value).toLocaleString("en-IN", {
        //             day: "2-digit",
        //             month: "short",
        //             year: "numeric",
        //             hour: "2-digit",
        //             minute: "2-digit",
        //         });

        //         return (
        //             <div>
        //                 <span className="mb-0">{formattedDate}</span>
        //             </div>
        //         );
        //     },
        // },
        {
            header: "Email",
            accessor: "email",
            render: (value, row) => (
                <div>
                    <h6 className="mb-0">{value}</h6>
                </div>
            ),
        },
        {
            header: "Access",
            accessor: "access",
            render: (value, row) => formatAccessPermissions(value)
        },
        // {
        //     header: "Actions",
        //     accessor: null,
        //     render: (_, row) => (
        //         <div className="d-flex justify-content-center">
        //             <Dropdown>
        //                 <Dropdown.Toggle variant="link" className="p-0 m-0 border-0">
        //                     <i className="ri-more-2-fill" style={{ cursor: "pointer" }}></i>
        //                 </Dropdown.Toggle>
        //                 <Dropdown.Menu align="end">
        //                     <Dropdown.Item
        //                         className="text-primary"
        //                         onClick={() => handleEditModal(row)}
        //                     >
        //                         Edit
        //                     </Dropdown.Item>
        //                     <Dropdown.Item
        //                         className="text-danger"
        //                         onClick={() => handleDeleteModal(row)}
        //                     >
        //                         Delete
        //                     </Dropdown.Item>
        //                 </Dropdown.Menu>
        //             </Dropdown>
        //         </div>
        //     ),
        // },
        ...(
            (userMgtAccess?.includes("UserMgt:update") || userMgtAccess?.includes("UserMgt:delete") ||  email === "contact@xpansecafe.com")
                ? [
                    {
                        header: "Actions",
                        accessor: null,
                        render: (_, row) => (
                            <div className="d-flex justify-content-start gap-4">
                                {(userMgtAccess?.includes("UserMgt:update") || email === "contact@xpansecafe.com") && (
                                    <i 
                                        className="ri-edit-line text-primary" 
                                        style={{ cursor: "pointer", fontSize: "18px" }}
                                        onClick={() => handleEditModal(row)}
                                        title="Edit"
                                    ></i>
                                )}
                                {(userMgtAccess?.includes("UserMgt:delete") || email === "contact@xpansecafe.com") && (
                                    <i 
                                        className="ri-delete-bin-line text-danger" 
                                        style={{ cursor: "pointer", fontSize: "18px" }}
                                        onClick={() => handleDeleteModal(row)}
                                        title="Delete"
                                    ></i>
                                )}
                            </div>
                        ),
                    }
                ] : [] 
        )
    ];

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
        handleGeneratePassword();
    };

    const handleSearchChange = (e) => {
        const searchValue = e.target.value;
        setSearchText(searchValue);
        
        if (searchValue.trim() === '') {
            setFilteredData(usersList);
        } else {
            const filtered = usersList.filter(user => 
                user.name.toLowerCase().includes(searchValue.toLowerCase()) ||
                user.email.toLowerCase().includes(searchValue.toLowerCase())
            );
            setFilteredData(filtered);
        }
    };

    const getRoles = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("role", { headers });
    
            if (response?.data?.status === true) {
                response?.data?.data?.roles.forEach((item, index) => {
                    item.serialNumber = index + 1;
                });
    
                setRoles(response?.data?.data?.roles);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getPaginatedData = () => {
        const startIndex = (page - 1) * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;
        return filteredData?.slice(startIndex, endIndex);
    };

    const getUsersList = async () => {
        setDataLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("admin-user-management", { headers });
            
            if (response?.data?.status === true) {
                response?.data?.data?.dbResponse.forEach((item, index) => {
                    item.serialNumber = index + 1;
                });
    
                setUsersList(response?.data?.data?.dbResponse);
                setFilteredData(response?.data?.data?.dbResponse);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setDataLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserInputData(prev => ({
            ...prev,
            [name]: value
        }));
        
        // Clear error when user types
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleSelectChange = (selected) => {
        setSelectedComponentData(selected);
    };

    const validateForm = () => {
        const newErrors = {};
        
        if (!userInputData.name.trim()) {
            newErrors.name = 'Name is required';
        }
        
        if (!userInputData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(userInputData.email)) {
            newErrors.email = 'Email is invalid';
        }
        
        if (!userInputData.password) {
            newErrors.password = 'Password is required';
        } else if (userInputData.password.length < 6) {
            newErrors.password = 'Password must be at least 6 characters';
        }
        
        if (!userInputData.access || userInputData.access.length === 0) {
            newErrors.access = 'At least one permission is required';
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async(e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            return;
        }
        
        setIsAddBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };

            const response = await axios.post('admin-user-management', userInputData, { headers });
            
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                getUsersList();
                setUserInputData({
                    name: "",
                    email: "",
                    password: "",
                    access: []
                });
                setOpenAddModal(false);
                setShowPassword(false);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if ( error.response?.status === 406 ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                } else if ( error.response?.status === 412 ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                } else {
                    errorMessage = 'An error occurred while creating the user';
                }
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsAddBtnLoading(false);
        }
    };

    const handleEditModal = (data) => {
        console.log("Edit Modal Data :", data);
        
        setOpenEditModal(true);
        setEditedData({
            _id: data?._id,
            name: data?.name,
            email: data?.email,
            password: '',
            access: data?.access,
            role: data?.role
        });
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditedData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleEditSubmit = async(e) => {
        e.preventDefault();
        setIsEditBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }; 

            // Don't send password if it's empty (not changed)
            const dataToSend = { ...editedData };
            if (!dataToSend.password) {
                delete dataToSend.password;
            }

            const response = await axios.put('admin-user-management', dataToSend, { headers });
            
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                getUsersList();
                setOpenEditModal(false);
                setShowEditPassword(false);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if ( error.response?.status === 406 ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                } else if ( error.response?.status === 412 ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                } else {
                    errorMessage = 'An error occurred while updating the user';
                }
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsEditBtnLoading(false);
        }
    };

    const handleDeleteModal = (data) => {
        setOpenDeleteModal(true);
        setUserId(data?._id);
    };

    const handleSubmitDeleteUser = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };
            const data = {
                _id: userId
            };
            
            const response = await axios.delete("admin-user-management", { data, headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getUsersList();
                setOpenDeleteModal(false);
            }
        } catch (error) {
            if (error.response?.status === 403) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            } else if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            } else {
                toast.error('An error occurred while deleting the user', {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsDeleteBtnLoading(false);
        }
    };

    const formatPermission = (permission) => {
        if (!permission) return "";

        // 1. Remove :action part (e.g., ":get")
        let name = permission.split(":")[0];

        // 2. Insert spaces before capital letters (PascalCase or camelCase)
        name = name.replace(/([a-z])([A-Z])/g, "$1 $2");

        // 3. Capitalize first letter of each word
        name = name.replace(/\b\w/g, (char) => char.toUpperCase());

        return name;
    };


    useEffect(() => {
        getRoles();
        getUsersList();
    }, []);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div
                    className="container shadow-sm"
                    style={{ backgroundColor: "white" }}
                >
                    <Row className="pt-4">
                        <Col>
                            <h5 className="fw-semibold">ADMIN USER MANAGEMENT</h5>
                        </Col>
                        <hr />
                    </Row>

                    <Row className='justify-content-between mt-2'>
                        <Col lg="4" md="6">
                            <div className="input-group w-100">
                                <input
                                    type="text"
                                    value={searchText}
                                    onChange={handleSearchChange}
                                    className="form-control"
                                    placeholder="Search for users..."
                                />
                                <button className="btn btn-primary" type="button">
                                    <i className="ri-search-line"></i>
                                </button>
                            </div>
                        </Col>
                        <Col lg="3" md="6" className="d-flex justify-content-end flex-column">
                            <Button
                                variant="primary"
                                className="fw-semibold"
                                onClick={handleOpenAddModal}
                            >
                                <i className="ri-add-line" style={{ marginRight: "5px" }}></i>
                                Add New User
                            </Button>
                        </Col>
                    </Row>

                    <Row>
                        <Row className='mt-3'>
                            <Col>
                                <ReusableTable
                                    columns={columns}
                                    data={getPaginatedData()}
                                    loading={dataLoading}
                                />
                            </Col>
                        </Row>
                    </Row>

                    {openAddModal && (
                        <Modal
                            show={openAddModal}
                            onHide={() => {
                                setOpenAddModal(false);
                                setErrors({});
                                setShowPassword(false);
                            }}
                            centered
                            size="xl"
                            aria-labelledby="VerticallyCenteredExample"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>ADD NEW USER</Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleSubmit}>
                                <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                    <Row>
                                        <Col xs={12} md={6} lg={4}>
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Name <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Name"
                                                    className="form-control"
                                                    name="name"
                                                    value={userInputData?.name}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.name}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.name}
                                                </Form.Control.Feedback>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6} lg={4}>
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Email <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    placeholder="Email"
                                                    className="form-control"
                                                    name="email"
                                                    value={userInputData?.email}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.email}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.email}
                                                </Form.Control.Feedback>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6} lg={4}>
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Password <span className="text-danger">*</span>
                                                </Form.Label>
                                                <InputGroup>
                                                    <Form.Control
                                                        type={showPassword ? "text" : "password"}
                                                        placeholder="Password"
                                                        className="form-control"
                                                        name="password"
                                                        value={userInputData?.password}
                                                        onChange={handleChange}
                                                        isInvalid={!!errors.password}
                                                    />
                                                    <Button 
                                                        variant="outline-secondary" 
                                                        onClick={togglePasswordVisibility}
                                                    >
                                                        <i className={showPassword ? "ri-eye-off-line" : "ri-eye-line"}></i>
                                                    </Button>
                                                    <Button 
                                                        variant="outline-primary" 
                                                        onClick={handleGeneratePassword}
                                                    >
                                                        Re-Generate
                                                    </Button>
                                                </InputGroup>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.password}
                                                </Form.Control.Feedback>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            <div className="mb-2">
                                                <Form.Label className="fw-semibold">
                                                    Permissions <span className="text-danger">*</span>
                                                </Form.Label>
                                                <PermissionSelector
                                                    componentData={componentData}
                                                    selectedPermissions={userInputData?.access || []}
                                                    onPermissionChange={(permissions) => 
                                                        setUserInputData(prev => ({
                                                            ...prev,
                                                            access: permissions
                                                        }))
                                                    }
                                                />
                                                {errors.access && (
                                                    <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                                                        {errors.access}
                                                    </div>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer className="d-flex flex-wrap justify-content-between">
                                    <Button 
                                        variant="outline-secondary" 
                                        onClick={() => {
                                            setOpenAddModal(false);
                                            setShowPassword(false);
                                        }}
                                        className="mb-2 mb-md-0"
                                    >
                                        Cancel
                                    </Button>
                                    <Button 
                                        variant="primary" 
                                        type="submit" 
                                        disabled={isAddBtnLoading}
                                        className="d-flex align-items-center"
                                    >
                                        {isAddBtnLoading ? (
                                            <>
                                                <Spinner size="sm" className="me-2" />
                                                Adding...
                                            </>
                                        ) : "ADD NEW USER"}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    )}

                    {openEditModal && (
                        <Modal
                            show={openEditModal}
                            onHide={() => {
                                setOpenEditModal(false);
                                setShowEditPassword(false);
                            }}
                            centered
                            size="xl"
                            aria-labelledby="VerticallyCenteredExample"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>UPDATE USER DETAILS</Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleEditSubmit}>
                                <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                    <Row>
                                        <Col xs={12} md={6} lg={6}>
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Name <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Name"
                                                    className="form-control"
                                                    name="name"
                                                    value={editedData?.name}
                                                    onChange={handleEditChange}
                                                />
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6} lg={6}>
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Email <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    placeholder="Email"
                                                    className="form-control"
                                                    name="email"
                                                    value={editedData?.email}
                                                    onChange={handleEditChange}
                                                />
                                            </div>
                                        </Col>
                                        {/* <Col xs={12} md={6} lg={4}>
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Password (Leave blank to keep current)
                                                </Form.Label>
                                                <InputGroup>
                                                    <Form.Control
                                                        type={showEditPassword ? "text" : "password"}
                                                        placeholder="New Password"
                                                        className="form-control"
                                                        name="password"
                                                        value={editedData?.password}
                                                        onChange={handleEditChange}
                                                    />
                                                    <Button 
                                                        variant="outline-secondary" 
                                                        onClick={toggleEditPasswordVisibility}
                                                    >
                                                        <i className={showEditPassword ? "ri-eye-off-line" : "ri-eye-line"}></i>
                                                    </Button>
                                                </InputGroup>
                                                <Form.Text className="text-muted">
                                                    Leave blank if you don't want to change the password
                                                </Form.Text>
                                            </div>
                                        </Col> */}
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            <div className="mb-2">
                                                <Form.Label className="fw-semibold">
                                                    Permissions <span className="text-danger">*</span>
                                                </Form.Label>
                                                <PermissionSelector
                                                    componentData={componentData}
                                                    selectedPermissions={editedData.access || []}
                                                    onPermissionChange={(permissions) => 
                                                        setEditedData(prev => ({
                                                            ...prev,
                                                            access: permissions
                                                        }))
                                                    }
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer className="d-flex flex-wrap justify-content-between">
                                    <Button 
                                        variant="outline-secondary" 
                                        onClick={() => {
                                            setOpenEditModal(false);
                                            setShowEditPassword(false);
                                        }}
                                        className="mb-2 mb-md-0"
                                    >
                                        Cancel
                                    </Button>
                                    <Button 
                                        variant="primary" 
                                        type="submit" 
                                        disabled={isEditBtnLoading}
                                        className="d-flex align-items-center"
                                    >
                                        {isEditBtnLoading ? (
                                            <>
                                                <Spinner size="sm" className="me-2" />
                                                Updating...
                                            </>
                                        ) : "UPDATE USER"}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    )}

                    {openDeleteModal && (
                        <Modal show={openDeleteModal} onHide={() => setOpenDeleteModal(false)} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Confirm Delete</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                Are you sure you want to delete this admin user? This action cannot be undone.
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setOpenDeleteModal(false)}>
                                    Cancel
                                </Button>
                                <Button variant="danger" onClick={handleSubmitDeleteUser}>
                                    {isDeleteBtnLoading ? (
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    ) : "Delete User"}
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    )}

                    {showPermissionsModal && (
                        <Modal
                            show={showPermissionsModal}
                            onHide={() => setShowPermissionsModal(false)}
                            centered
                            size="lg"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>{modalTitle}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                            {(() => {
                                // Categorize permissions for modal display
                                const categorizeForModal = (permissions) => {
                                const categorized = {
                                    get: [],
                                    add: [],
                                    update: [],
                                    delete: [],
                                    other: [],
                                };

                                permissions?.forEach((permission) => {
                                    if (typeof permission === "string") {
                                    const [resource, action] = permission.split(":");
                                    const actionType = action?.toLowerCase();

                                    if (["get", "view", "read"].includes(actionType)) {
                                        categorized.get.push(`${resource}:${action}`);
                                    } else if (["add", "create"].includes(actionType)) {
                                        categorized.add.push(`${resource}:${action}`);
                                    } else if (["update", "edit", "modify"].includes(actionType)) {
                                        categorized.update.push(`${resource}:${action}`);
                                    } else if (["delete", "remove"].includes(actionType)) {
                                        categorized.delete.push(`${resource}:${action}`);
                                    } else {
                                        categorized.other.push(`${resource}:${action}`);
                                    }
                                    } else if (typeof permission === "object" && permission.component) {
                                    if (permission.actions && Array.isArray(permission.actions)) {
                                        permission.actions.forEach((action) => {
                                        const actionType = action.toLowerCase();
                                        if (["get", "view", "read"].includes(actionType)) {
                                            categorized.get.push(`${permission.component}:${action}`);
                                        } else if (["add", "create"].includes(actionType)) {
                                            categorized.add.push(`${permission.component}:${action}`);
                                        } else if (["update", "edit", "modify"].includes(actionType)) {
                                            categorized.update.push(`${permission.component}:${action}`);
                                        } else if (["delete", "remove"].includes(actionType)) {
                                            categorized.delete.push(`${permission.component}:${action}`);
                                        } else {
                                            categorized.other.push(`${permission.component}:${action}`);
                                        }
                                        });
                                    }
                                    }
                                });

                                // Remove duplicates and sort
                                Object.keys(categorized).forEach((key) => {
                                    categorized[key] = [...new Set(categorized[key])].sort();
                                });

                                return categorized;
                                };

                                const categorized = categorizeForModal(modalPermissions);
                                const actionLabels = {
                                get: "View Access",
                                add: "Create Access",
                                update: "Edit Access",
                                delete: "Delete Access",
                                other: "Other Permissions",
                                };

                                // Map action type to badge colors
                                const badgeColors = {
                                get: "success",   // green
                                add: "warning",   // yellow
                                update: "primary", // blue
                                delete: "danger", // red
                                other: "secondary", // gray
                                };

                                return (
                                <div className="permission-categories-modal">
                                    {Object.entries(categorized).map(([actionType, permissions]) => {
                                    if (permissions.length === 0) return null;

                                    return (
                                        <div key={actionType} className="mb-3">
                                        <h6 className="fw-semibold text-muted mb-2">
                                            {actionLabels[actionType]} ({permissions?.length})
                                        </h6>
                                        <div className="d-flex flex-wrap gap-1 ms-2">
                                            {permissions?.map((permission, index) => (
                                            <span
                                                key={index}
                                                style={{ fontSize: '13px' }}
                                                className={`badge bg-${badgeColors[actionType]} mb-1`}
                                            >
                                                {formatPermission(permission)}
                                            </span>
                                            ))}
                                        </div>
                                        </div>
                                    );
                                    })}
                                </div>
                                );
                            })()}
                            </Modal.Body>
                            <Modal.Footer>
                            <Button
                                variant="secondary"
                                onClick={() => setShowPermissionsModal(false)}
                            >
                                Close
                            </Button>
                            </Modal.Footer>
                        </Modal>
                    )}

                </div>
            </div>
        </React.Fragment>
    );
};

export default AdminUserMgt;